// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__wEhJy","button":"menu_button__Z9+-s","divider":"menu_divider__E4U+W"};